export default __webpack_public_path__ + "locales/el-GR/Notifications.json?hash=9cc644e1238ed207f9ad7cb7af18f60b";